import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { OccEndpointsService, Price, ProductSearchPage, SearchConfig } from '@spartacus/core';
import { Observable } from 'rxjs';

import { CustomerPrice } from '@app/core/types/backend/customer-price.type';
import { CustomerPrices } from '@app/core/types/backend/customer-prices.type';
import { DpOccProduct } from '@app/core/types/backend/dp-product.interface';
import type { ProductDownloadList } from '@app/core/types/product-download-list.type';

@Injectable({ providedIn: 'root' })
export class DpProductsApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);

  getProducts(query: string, config: SearchConfig): Observable<ProductSearchPage> {
    return this.#httpClient.get<ProductSearchPage>(
      this.#occEndpoints.buildUrl('productPsf', { queryParams: { query, ...config } })
    );
  }

  getProductsPrices(productCodes: string[]): Observable<CustomerPrices> {
    return this.#httpClient.get<CustomerPrices>(
      this.#occEndpoints.buildUrl('productPrices', { queryParams: { productCodes } })
    );
  }

  getFormattedProductPrice(priceValue: number): Observable<Price> {
    return this.#httpClient.get<Price>(this.#occEndpoints.buildUrl('formatPrice', { queryParams: { priceValue } }));
  }

  getProductDetails(productCode: string): Observable<DpOccProduct> {
    return this.#httpClient.get<DpOccProduct>(
      this.#occEndpoints.buildUrl('productDetails', { urlParams: { productCode } })
    );
  }

  getProductDownloads(productCode: string): Observable<ProductDownloadList> {
    return this.#httpClient.get<ProductDownloadList>(
      this.#occEndpoints.buildUrl('productDownloads', { urlParams: { productCode } })
    );
  }

  getProductClassifications(productCode: string): Observable<DpOccProduct> {
    return this.#httpClient.get<DpOccProduct>(
      this.#occEndpoints.buildUrl('productClassifications', { urlParams: { productCode } })
    );
  }

  getProductPrice(productCode: string): Observable<CustomerPrice> {
    return this.#httpClient.get<CustomerPrice>(
      this.#occEndpoints.buildUrl('productPrice', { urlParams: { productCode } })
    );
  }

  getRelatedPartsConfig(code: string): Observable<ProductSearchPage> {
    return this.#httpClient.get<ProductSearchPage>(
      this.#occEndpoints.buildUrl('productRelatedParts', {
        queryParams: {
          query: `:size-asc:code:${code}`,
          pageSize: 50,
          currentPage: 0
        }
      })
    );
  }
}
